module.exports = __webpack_public_path__ + "media/homepage/briana-berger-6c66f8b9.webp";